import { useCustomTranslation } from "../../hooks/useCustomTranslation";

export const GalleryEmpty = (): JSX.Element => {
  const { t } = useCustomTranslation("Notifications");
  return (
    <div className="gallery-notice-container">
      <div className="gallery-notice-container__content">
        <p>{t("SorryNothingHere")}</p>
        <p>{t("PossiblyRemoved")}</p>
        <p>{t("TryAgain")}</p>
      </div>
    </div>
  );
};
